export default __webpack_public_path__ + "static/IMG_1258-97f73eaa33f5d8f29743a09807628cc1.jpg";